export const AREA_COLOR_PALETTE: string[] = ['#FF0000', '#FFFF00', '#0000FF', '#008000', '#C0C0C0','#FF8C00', '#00FFFF', '#AA336A', '#1a759f', '#dbff00', '#660708', '#06d6a0', '#70e000'];
